export default __webpack_public_path__ + "static/foundations-carousel-panel3-560b12fd4615507a5a9422654d67518dadcb83f00647308de76d03a76ad36271.png";